import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Building2 } from 'lucide-react';

const Row = ({ label, value }) => (
  <div className="flex justify-between text-sm">
    <span className="text-gray-500">{label}</span>
    <span className="font-medium">{value}</span>
  </div>
);

const FundamentalsCard = ({ stockData }) => (
  <Card className="hover:shadow-lg transition-shadow" data-testid="research-fundamentals-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-lg">
        <Building2 className="text-purple-600" size={20} />
        Fundamental Analysis
      </CardTitle>
    </CardHeader>
    <CardContent>
      {stockData ? (
        <div className="space-y-3">
          <Row label="Market Cap" value={stockData.marketCap ? `$${(stockData.marketCap / 1e9).toFixed(1)}B` : 'N/A'} />
          <Row label="P/E Ratio" value={stockData.peRatio?.toFixed(2) || 'N/A'} />
          <Row label="EPS" value={stockData.eps ? `$${stockData.eps.toFixed(2)}` : 'N/A'} />
          <Row label="52W High" value={stockData.fiftyTwoWeekHigh ? `$${stockData.fiftyTwoWeekHigh.toFixed(2)}` : 'N/A'} />
          <Row label="52W Low" value={stockData.fiftyTwoWeekLow ? `$${stockData.fiftyTwoWeekLow.toFixed(2)}` : 'N/A'} />
        </div>
      ) : (
        <p className="text-gray-500 text-sm">Search for a stock to see fundamentals</p>
      )}
    </CardContent>
  </Card>
);

export default FundamentalsCard;
